import React, {useState, useEffect} from 'react'
import "./glitchy-background.styles.css"

const defaultWords = [
{ word: 'Diligence', definition: 'Careful and consistent effort.', sentence: 'She showed great diligence in her assignments.' },
{ word: 'Improvement', definition: 'The process of becoming better at something.', sentence: 'Daily practice leads to improvement .' },
{ word: 'Effort', definition: 'The use of energy to do something.', sentence: 'Learning a new language requires consistent effort.' },
{ word: 'Consistent', definition: 'Showing steady behavior.', sentence: 'She has been consistent in studying English every day.' },
{ word: 'Fluent', definition: 'Able to speak or write a language easily.', sentence: 'After years of study, she became fluent in English.' },
{ word: 'Study', definition: 'The act of devoting time to learning.', sentence: 'Regular study helps students improve their English.' },
{ word: 'Patience', definition: 'The ability to keep trying in difficult times.', sentence: 'Learning a language takes patience.' },
];

const GlitchyBackground = ({newWords = defaultWords, theme = "red-theme" }) => {


    // const randomPercent = () => Math.floor(Math.random() * 85) - 10 + '%';

      const [positions, setPositions] = useState([]);

  useEffect(() => {
    const n = newWords.length;
    const cols = Math.ceil(Math.sqrt(n));
    const rows = Math.ceil(n / cols);

    const cells = [];
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        if (cells.length < n) cells.push({ r, c });
      }
    }

    for (let i = cells.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cells[i], cells[j]] = [cells[j], cells[i]];
    }

    const cellW = 100 / cols;
    const cellH = 100 / rows;
    const jitter = 0.55;

    const generatePositions = cells.map(({ r, c }) => {
      const topPct = r * cellH + Math.random() * cellH * jitter;
      const leftPct = c * cellW + Math.random() * cellW * jitter;
      return {
        top: `${topPct}%`,
        left: `${leftPct}%`,
        animationDuration: `${6 + Math.random() * 6}s`,
        animationDelay: `${Math.random() * 5}s`,
      };
    });

    setPositions(generatePositions);
  }, [newWords]);


 if (!positions.length) return null;

  return (
    <div className = {`floating-words-wrapper ${theme}`}>
 <div className="glitchy-container">
      {newWords.map(({ word, definition, sentence }, i) => (
  <div
    key={i}
    className="glitchy-word-wrapper"
    style={positions[i]}
    title={`${word}: ${definition} - Example: ${sentence}`}     
  >
    <div className="glitchy-word" data-text={word}>
      {word}
    </div>
    <div className="glitchy-info">
      <p className="definition">{definition}</p>
      <p className="example">"{sentence}"</p>
    </div>
  </div>
))}

    </div>
</div>
  )
}

export default React.memo(GlitchyBackground);

